import React from 'react';
import styles from './OuterCard.module.scss';
import {ReactComponent as OkIcon} from 'assets/img/ok.svg';
import {ReactComponent as EclipseLoaderIcon} from 'assets/img/eclipseLoader.svg';
import SkeletonPlaceHolder, {eSkeletonVariant} from 'gui/components/skeletonPlaceHolder';

export interface IOuterCardProps {
  title?: string;
  content?: string[] | string | any[] | any;
  children?: any;
  loading?: boolean;
}

const contentToRows = (contentLines, loading = false) => (!Array.isArray(contentLines) ? [contentLines] : contentLines)
  .filter(content => content)
  .map(content => typeof content === 'string' ? content.trim() : content)
  .map((content, index) => loading ?
    <SkeletonPlaceHolder key={index} width={300} className={styles.middle} variant={eSkeletonVariant.text}/> :
    <li key={index}>{content}</li>);

const OuterCard = (props: IOuterCardProps) => {
  return (<div className={styles.OuterCard}>
      {props.loading ? <EclipseLoaderIcon className={styles.okIcon}/> : <OkIcon className={styles.okIcon}/>}
      <h3 className={styles.title}>
        {props.loading ?
          <SkeletonPlaceHolder width={175} className={styles.middle} variant={eSkeletonVariant.text}/> : props.title}
      </h3>
      <ul className={styles.content}>
        {contentToRows(props.content, props.loading)}
      </ul>
      {props.children}
    </div>
  );
};

OuterCard.defaultProps = {
  title: '',
  content: '',
  children: null,
  loading: false,
};

export default React.memo(OuterCard);
